import { Page } from '@app/components/page/Page';
import { LoggerIcon } from '@app/modules/logger/LoggerIcon';
import { LinkItem } from '@mi-front/ui';
import { PropsWithChildren, useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';

const loggerReportsTitleMessage = defineMessage({
  id: 'logger.reports.loggerReportsTitle',
  defaultMessage: 'Reportes Logger',
});

const streamQualityTabMessage = defineMessage({
  id: 'logger.reports.streamQuality.tabLabel',
  defaultMessage: 'Stream Quality',
});

type Props = PropsWithChildren;

/**
 * Shared layout for logger report screens: document title, header, and tabs between report types.
 */
export function BaseLoggerReportsPage({ children }: Props) {
  const { $t } = useIntl();

  const tabs: readonly LinkItem[] = useMemo(
    () => [
      {
        to: '/logger/reports/stream-quality',
        text: $t(streamQualityTabMessage),
      },
    ],
    [$t],
  );

  return (
    <Page htmlTitle={$t(loggerReportsTitleMessage)}>
      <Page.Header icon={<LoggerIcon />} title={$t(loggerReportsTitleMessage)} tabs={tabs} />
      {children}
    </Page>
  );
}
